import lottie from 'lottie-web';

type Elements = {
  animations: HTMLDivElement[];
};

type Divider = {
  elements: Elements;
  init: () => Promise<void>;
  loadAndPlayAnimations: () => void;
  getPath: (file: string) => string;
};

const divider: Divider = {
  elements: {
    animations: [],
  },

  async init() {
    this.elements.animations = Array.from(document.querySelectorAll('.module--divider .module__animation'));
    this.loadAndPlayAnimations();
  },

  async loadAndPlayAnimations() {
    if (this.elements.animations.length > 0) {
      this.elements.animations.forEach(async (element) => {
        try {
          if(!element.dataset.file) return;
          
          const response = await fetch(this.getPath(element.dataset.file));
          if (!response.ok) {
            throw new Error(`Failed to load animation: ${response.status}`);
          }
          
          const file = await response.json();

          lottie.loadAnimation({
            container: element,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: file,
          });
        } catch (error) {
          console.warn('Error loading animation:', error);
          // Add fallback class for CSS-based animation if needed
          element.classList.add('animation-error');
        }
      });
    }
  },

  getPath(file) {
    return `${window.curtis.themeurl}/public/dividers/animated/${file}`;
  }
};

export default divider;
